// Copyright (c) 2026 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Ahmed Hosny

/**
 * Helpers for the BrokerageBackfillPage. Extracted to a standalone module so
 * the parsing logic is unit-testable without rendering the page.
 */
const UUID_REGEX = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;

export interface ParseBrokerageIdsResult {
  ids: string[];
  invalid: string[];
}

/**
 * Splits a comma- or whitespace-separated user-typed string into UUID tokens.
 * Tokens that don't match the canonical 8-4-4-4-12 UUID shape are returned
 * separately in `invalid` so the UI can warn without sending them to the BFF.
 *
 * Empty/whitespace input returns empty arrays — caller treats that as
 * "backfill everything".
 */
export function parseBrokerageIds(raw: string): ParseBrokerageIdsResult {
  if (!raw) {
    return { ids: [], invalid: [] };
  }
  const tokens = raw
    .split(/[,\s]+/)
    .map(t => t.trim())
    .filter(Boolean);
  const ids: string[] = [];
  const invalid: string[] = [];
  for (const t of tokens) {
    if (UUID_REGEX.test(t)) {
      ids.push(t);
    } else {
      invalid.push(t);
    }
  }
  return { ids, invalid };
}
